import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Services from "../views/Services.vue";
import Service from "../views/Service.vue";
import Contact from "../views/Contact.vue";
import News from "../views/News.vue";
import Newsdetail from "../views/Newsdetail.vue";
// import Webinar from "../views/Webinar.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about-us",
    name: "About",
    component: About
  },
  {
    path: "/our-services",
    name: "Services",
    component: Services
  },
  {
    path: "/service/:id",
    name: "Service",
    component: Service
  },
  {
    path: "/news",
    name: "News",
    component: News
  },
  {
    path: "/news-detail/:id",
    name: "Newsdetail",
    component: Newsdetail
  },
  {
    path: "/contact-us",
    name: "Contact",
    component: Contact
  }
  // {
  //   path: "/webinar",
  //   name: "Webinar",
  //   component: Webinar
  // }
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
